<script>
import ManageButton from "@/view/pages/button.vue";

export default {
  name: "transactionsList",

  components: {
    ManageButton,
  },

  props: {
    value: Boolean,
    infoId: {
      type: [Number,String],
      default: 0
    },
  },

  data() {
    return {
      tab: 0,
      loading: false,
      loadingArchived: false,
      loadingTrans: false,
      actionLoading: null,

      cardList: [],
      archivedCardList: [],
      transactionList: [],

      detailsDialog: false,
      selectedCard: null,

      // متغیرهای نمایش عکس
      imageDialog: false,
      previewImage: null,
      zoomLevel: 1,

      metaButtons: {
        buttons: [
          {
            name: "accept",
            label: "تایید کردن",
            icon: "thumbs-up",
            class: "btn-success border-2 rounded-pill",
            action: (data) =>
              this.action(data, "changeStatusForTransaction", "verified"),
            status: "",
          },
          {
            name: "reject",
            label: "رد کردن",
            icon: "thumbs-down",
            class: "btn-deactivate border-2 rounded-pill",
            action: (data) =>
              this.action(data, "changeStatusForTransaction", "rejected"),
            status: "",
          },
        ],
      },

      headers: [
        { text: "شناسه", value: "id", align: "start" },
        { text: "مبلغ (تومان)", value: "amount" },
        { text: "پرداخت کننده", value: "user" },
        { text: "تاریخ", value: "created_at_p" },
        { text: "تصویر", value: "img", align: "center" },
        { text: "وضعیت", value: "status" },
        { text: "عملیات", value: "actions", sortable: false, align: "center" },
      ],
    };
  },

  watch: {
    "infoId"(newId) {
      if (newId) {
        this.fetchCard();
        this.archivedCardList = [];
        if (this.tab === 1) this.fetchArchivedCards();
      }
    },
    value(val) {
      if (val) {
        this.$nextTick(() => {
          this.fetchCard();
          if (this.tab === 1) this.fetchArchivedCards();
        });
      }
    },
    tab(val) {
      if (val === 1 && this.archivedCardList.length === 0) {
        this.fetchArchivedCards();
      }
    },
    imageDialog(val) {
      if (!val) {
        this.zoomLevel = 1;
        this.previewImage = null;
      }
    },
  },

  mounted() {
    this.fetchCard();
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    // متدهای مربوط به عکس و زوم
    openImageModal(imgUrl) {
      if (!imgUrl) return;
      this.previewImage = imgUrl;
      this.zoomLevel = 1;
      this.imageDialog = true;
    },

    zoomIn() {
      if (this.zoomLevel < 3) this.zoomLevel += 0.25;
    },

    zoomOut() {
      if (this.zoomLevel > 0.5) this.zoomLevel -= 0.25;
    },

    resetZoom() {
      this.zoomLevel = 1;
    },

    fetchCard() {
      if (!this.infoId) return;
      this.loading = true;
      this.$api
        .get(`/v1/testQr/smart`, {
          params: { qr_id: this.infoId },
        })
        .then(({ data }) => {
          this.cardList = data.data || [];
        })
        .catch((error) => {
          console.error("Error:", error);
          this.$toast.error("خطا در دریافت لیست کارت‌ها");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    action(data, func, type) {
      this[func](data, type);
    },

    changeStatusForTransaction(value, type) {
      this.actionLoading = true;
      this.$api
        .post(`/v1/testQr/smart/transaction/state/${value.id}`, {
          status: type,
        })
        .then(({ data }) => {
          this.$toast.success(`تراکنش با موفقیت تغییر شد`);
          this.fetchTransactions(this.selectedCard);
        })
        .catch((error) => {
          this.$toast.error(`خطا در تراکنش`);
          console.error(error);
        })
        .finally(() => {
          this.actionLoading = null;
        });
    },

    fetchArchivedCards() {
      if (!this.infoId) return;
      this.loadingArchived = true;
      this.$api
        .get("/v1/testQr/smart/archived", {
          params: { qr_id: this.infoId },
        })
        .then(({ data }) => {
          this.archivedCardList = data.data || [];
        })
        .catch((error) => {
          console.error("Error:", error);
          this.$toast.error("خطا در دریافت لیست کارت‌های بایگانی");
        })
        .finally(() => {
          this.loadingArchived = false;
        });
    },

    fetchTransactions(cardItem) {
      if (!cardItem) return;
      this.loadingTrans = true;
      this.transactionList = [];
      this.$api
        .get(`v1/testQr/smart/transactions/${this.infoId}`, {
          params: { carts: cardItem.id },
        })
        .then(({ data }) => {
          this.transactionList = data.data || [];
        })
        .catch((error) => {
          console.error("Error:", error);
          this.$toast.error("خطا در دریافت لیست تراکنش‌ها");
        })
        .finally(() => {
          this.loadingTrans = false;
        });
    },

    handleReload() {
      if (this.tab === 0) this.fetchCard();
      else this.fetchArchivedCards();
    },

    openDetails(card) {
      this.selectedCard = card;
      this.detailsDialog = true;
      this.fetchTransactions(card);
    },

    formatPrice(price) {
      if (!price) return "0";
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getStatusDetails(status) {
      const map = {
        pending: { text: "در انتظار", color: "orange--text text--darken-2" },
        reserved: { text: "رزرو شده", color: "blue--text text--darken-2" },
        verified: { text: "تایید شده", color: "green--text text--darken-2" },
        rejected: { text: "رد شده", color: "red--text text--darken-2" },
        expired: { text: "منقضی", color: "grey--text text--darken-1" },
      };
      return map[status] || { text: status, color: "grey--text" };
    },

    formatCardNumber(value) {
      if (!value) return "";
      const rawValue = value.toString().replace(/\D/g, "");
      const truncated = rawValue.slice(0, 16);
      return truncated.replace(/(\d{4})/g, "$1 ").trim();
    },

    typeText(value) {
      switch (value) {
        case "pending":
          return {
            text: "در انتظار بررسی",
            color: "orange lighten-4",
            icon: "mdi-clock-outline",
          };
        case "reserved":
          return {
            text: "رزرو شده",
            color: "cyan lighten-4",
            icon: "mdi-lock-clock",
          };
        case "verified":
          return {
            text: "تایید شده",
            color: "green lighten-4",
            icon: "mdi-check-circle-outline",
          };
        case "rejected":
          return {
            text: "رد شده",
            color: "red lighten-4",
            icon: "mdi-close-circle-outline",
          };
        case "expired":
          return {
            text: "منقضی شده",
            color: "grey lighten-2",
            icon: "mdi-timer-off-outline",
          };
        case "special":
          return {
            text: "اختصاصی",
            color: "purple lighten-4",
            icon: "mdi-star-circle-outline",
          };
        default:
          return {
            text: value || "نامشخص",
            color: "grey lighten-4",
            icon: "mdi-help-circle-outline",
          };
      }
    },
  },
};
</script>

<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: 'مدیریت کارت‌های هوشمند' }"
    hide-confirm
    max-width="800"
    reloadable
    :hideConfirm="true"
    :persistent="true"
    @reload="handleReload"
  >
    <custom-tabs v-model="tab" grow>
      <template v-slot:staticTabs>
        <v-tab>
          <v-icon left>mdi-credit-card-check-outline</v-icon>
          کارت‌های فعال
        </v-tab>

        <v-tab>
          <v-icon left>mdi-archive-arrow-down-outline</v-icon>
          کارت‌های بایگانی
        </v-tab>
      </template>

      <template v-slot:middle>
        <div class="py-2"></div>
      </template>

      <template v-slot:staticItems>
        <v-tab-item>
          <div class="pa-3">
            <p class="text-caption grey--text">
              برای دیدن لیست تراکنش‌ها روی کارت مورد نظر کلیک کنید.
            </p>

            <div
              v-if="loading"
              class="d-flex justify-center align-center mt-10"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>

            <div
              v-else-if="cardList.length === 0"
              class="d-flex flex-column align-center mt-10 grey--text"
            >
              <v-icon size="64" color="grey lighten-2"
                >mdi-credit-card-off-outline</v-icon
              >
              <span class="mt-2">کارت فعالی یافت نشد</span>
            </div>

            <v-row v-else class="mb-4">
              <v-col v-for="(card, index) in cardList" :key="card.id" cols="12">
                <v-card
                  class="pa-3 hover-card"
                  @click="openDetails(card)"
                  outlined
                  hover
                >
                  <div class="d-flex align-center">
                    <div class="d-flex align-center mr-2 ml-4 grab-handle">
                      <v-chip
                        class="mr-2 font-weight-bold"
                        color="primary"
                        label
                        small
                        >{{ index + 1 }}</v-chip
                      >
                    </div>
                    <div class="flex-grow-1">
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <div class="font-weight-bold text-h6 mb-1">
                            {{ card.bank_name }}
                          </div>
                          <div class="grey--text text-body-2">
                            <span v-if="card.owner_name">{{
                              card.owner_name
                            }}</span>
                            <span
                              v-if="card.cart_number || card.card_number"
                              class="mr-2"
                              style="letter-spacing: 2px"
                              dir="ltr"
                            >
                              {{
                                formatCardNumber(
                                  card.cart_number || card.card_number
                                )
                              }}
                            </span>
                          </div>
                        </div>
                        <v-btn icon small color="grey">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div
                    class="status-bar mt-3 d-flex justify-space-around grey lighten-4 rounded pa-2"
                  >
                    <div
                      v-for="(stat, index) in card.transactions_detail"
                      :key="index"
                      class="text-center"
                    >
                      <div class="caption grey--text">
                        {{ getStatusDetails(stat.status).text }}
                      </div>
                      <div
                        class="font-weight-bold"
                        :class="getStatusDetails(stat.status).color"
                      >
                        {{ stat.count }} ریال
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="pa-3">
            <p class="text-caption grey--text">
              لیست کارت‌هایی که بایگانی شده‌اند.
            </p>

            <div
              v-if="loadingArchived"
              class="d-flex justify-center align-center mt-10"
            >
              <v-progress-circular
                indeterminate
                color="indigo"
              ></v-progress-circular>
            </div>

            <div
              v-else-if="archivedCardList.length === 0"
              class="d-flex flex-column align-center mt-10 grey--text"
            >
              <v-icon size="64" color="grey lighten-2"
                >mdi-archive-off-outline</v-icon
              >
              <span class="mt-2">هیچ کارتی در بایگانی وجود ندارد</span>
            </div>

            <v-row v-else class="mb-4">
              <v-col
                v-for="(card, index) in archivedCardList"
                :key="card.id"
                cols="12"
              >
                <v-card
                  class="pa-3 hover-card grey lighten-5"
                  @click="openDetails(card)"
                  outlined
                  hover
                  style="border-style: dashed"
                >
                  <div class="d-flex align-center">
                    <div class="mr-2 ml-4">
                      <v-icon color="grey">mdi-archive</v-icon>
                    </div>
                    <div class="flex-grow-1">
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <div class="font-weight-bold text-h6 mb-1">
                            {{ card.bank_name }}
                            <span class="text-caption red--text"
                              >(بایگانی)</span
                            >
                          </div>
                          <div class="grey--text text-body-2">
                            <span v-if="card.owner_name">{{
                              card.owner_name
                            }}</span>
                            <span
                              v-if="card.cart_number || card.card_number"
                              class="mr-2"
                              style="letter-spacing: 2px"
                              dir="ltr"
                            >
                              {{
                                formatCardNumber(
                                  card.cart_number || card.card_number
                                )
                              }}
                            </span>
                          </div>
                        </div>
                        <v-btn icon small color="grey">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <div
                    class="status-bar mt-3 d-flex justify-space-around grey lighten-4 rounded pa-2"
                  >
                    <div
                      v-for="(stat, index) in card.transactions_detail"
                      :key="index"
                      class="text-center"
                    >
                      <div class="caption grey--text">
                        {{ getStatusDetails(stat.status).text }}
                      </div>
                      <div
                        class="font-weight-bold"
                        :class="getStatusDetails(stat.status).color"
                      >
                        {{ stat.count }} ریال
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
      </template>
    </custom-tabs>

    <custom-popup
      v-model="detailsDialog"
      :cons="{
        title: selectedCard
          ? `تراکنش‌های ${selectedCard.bank_name}`
          : 'لیست تراکنش‌ها',
      }"
      hide-confirm
      max-width="900"
    >
      <v-card flat>
        <v-card-text class="pa-0">
          <vue-table
            :headers="headers"
            :data="transactionList"
            :loading.sync="loadingTrans"
            loading-text="در حال دریافت تراکنش‌ها..."
            no-data-text="تراکنشی برای این کارت ثبت نشده است"
          >
            <template v-slot:item.amount="{ item }">
              <span class="font-weight-bold">{{
                formatPrice(item.amount)
              }}</span>
            </template>

            <template v-slot:user="{ item }">
              <span v-if="item.user">
                {{ item.user.name }} {{ item.user.family }}
              </span>
              <span v-else class="grey--text caption">ناشناس</span>
            </template>

            <template v-slot:img="{ item }">
              <div class="d-flex justify-center">
                <v-tooltip bottom v-if="item.img && item.img.url">
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      :src="item.img.url"
                      max-width="40"
                      max-height="40"
                      class="rounded cursor-pointer hover-zoom"
                      @click.stop="openImageModal(item.img.url)"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                            size="20"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </template>
                  <span>مشاهده تصویر</span>
                </v-tooltip>
                <span v-else class="grey--text text-caption">-</span>
              </div>
            </template>

            <template v-slot:item.created_at_p="{ item }">
              <span class="font-weight-bold">{{ item.created_at_p }}</span>
            </template>

            <template v-slot:status="{ item }">
              <v-chip :color="typeText(item.status).color" small>
                <v-icon left :color="typeText(item.status).color" x-small>
                  {{ typeText(item.status).icon }}
                </v-icon>
                {{ typeText(item.status).text }}
              </v-chip>
            </template>

            <template v-slot:actions="{ item }">
              <manage-button :data="item" :meta="metaButtons" />
            </template>
          </vue-table>
        </v-card-text>

        <v-card-actions class="justify-end pa-3">
          <v-btn text color="grey darken-1" @click="detailsDialog = false">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <custom-popup
      v-model="imageDialog"
      :cons="{ title: 'تصویر تراکنش' }"
      hide-confirm
      max-width="800"
    >
      <v-card flat>
        <v-toolbar dense flat color="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn icon @click="zoomOut">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
          <div
            class="mx-2 font-weight-bold grey--text text--darken-2"
            style="min-width: 50px; text-align: center"
          >
            {{ Math.round(zoomLevel * 100) }}%
          </div>
          <v-btn icon @click="zoomIn">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
          <v-btn icon @click="resetZoom" title="بازنشانی" class="ml-2">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>

        <div
          class="d-flex justify-center align-center overflow-auto grey lighten-3"
          style="height: 500px; position: relative"
        >
          <img
            v-if="previewImage"
            :src="previewImage"
            alt="Transaction Image"
            :style="{
              transform: `scale(${zoomLevel})`,
              transition: 'transform 0.2s ease',
            }"
            style="max-width: 100%; max-height: 100%; object-fit: contain"
          />
          <div v-else class="grey--text">تصویری موجود نیست</div>
        </div>

        <v-card-actions class="justify-end pa-3">
          <v-btn text color="primary" @click="imageDialog = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </custom-popup>
</template>

<style scoped>
.hover-card {
  transition: all 0.2s ease;
  cursor: pointer;
}

.hover-card:hover {
  border-color: var(--v-primary-base) !important;
  background-color: #f5faff !important;
}

.grey.lighten-5.hover-card:hover {
  background-color: #eeeeee !important;
  border-color: #9e9e9e !important;
}

.hover-zoom {
  transition: transform 0.2s;
}
.hover-zoom:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
</style>
